import Region from "../../../../../models/Region";

function isPosFinite(x) {
  return Number.isFinite(x) && x >= 0;
}

class Read {
  constructor(data, chr, graphKeyIndex) {
    const readratio = data[graphKeyIndex.readratio];
    const expected = data[graphKeyIndex.expected];
    const min = data[graphKeyIndex.minNorm] / expected;
    const max = data[graphKeyIndex.maxNorm] / expected;
    const val = readratio;
    const start = data[graphKeyIndex.start];
    const end = data[graphKeyIndex.end];
    this.start = start;
    this.end = end;

    this.min = Math.max(0, min);
    this.max = Math.min(100, max);
    this.expected = Number(expected);
    this.val = Number(val);
    this.readratio = Number(readratio);
    this.isOut = min > val || max < val;
    this.region = new Region(start, end, chr);

    this.shouldShow =
      isPosFinite(this.min) &&
      isPosFinite(this.max) &&
      isPosFinite(this.val) &&
      isPosFinite(this.readratio);

    this.original = data;
  }
}

export default Read;
